const KREEDALABS_EMAIL_DOMAIN = "@kreedalabs.com";

export const isKreedalabsUser = (email?: string | null): boolean => {
  if (!email) {
    return false;
  }

  return email.trim().toLowerCase().endsWith(KREEDALABS_EMAIL_DOMAIN);
};
